import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Component from '../components/summary.step.jsx'
import actions from '../actions/summary'
import costsActions from '../actions/costs'
import cardActions from '../actions/paymentMethod'
import {push} from 'react-router-redux'

class Container extends React.Component {

  constructor(props) {
    super(props)

    props.getCards()
    props.getTransactionCost()
  }

  confirm = () => {
    this.props.modifyTransaction()
      .then(success => {
        if (success) {
          this.props.confirm()
            .then(success => {
              if (success) {
                window.dataLayer.push({
                  'event': 'form_enviado',
                })
                this.props.requestNextStep()
              }
            })
        }
      })
  }

  goToPayment = () => {
    this.props.requestSpecificStep('payment', 'summary', 'summary')
  }

  render() {
    return <Component {...this.props} confirm={this.confirm} goToPayment={this.goToPayment}/>
  }

  static propTypes = {
    getCards: PropTypes.func.isRequired,
    modifyTransaction: PropTypes.func.isRequired,
    confirm: PropTypes.func.isRequired,
    requestNextStep: PropTypes.func.isRequired,
    requestSpecificStep: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const data = state.ui.depositV2.summary
  const timeSlot = data.get('timeslots').toArray().find(t => t.get('ID') === data.get('timeslot'))
  return {
    requireCardForDeposit: data.get('requireCardForDeposit'),
    address: data.get('addresses').toArray().find(a => a.ID === data.get('address')),
    date: data.get('date').hour(timeSlot.get('Hour')).minute(timeSlot.get('Minute')),
    cards: data.get('cards').toArray(),
    card: data.get('cards').toArray().find(c => c.ID === data.get('card')),
    transactionCost: data.get('transactionCost'),
    comment: data.get('comment'),
    isConfirming: data.get('isConfirming'),
    isFetchingConfigKeys: data.get('isFetchingConfigKeys'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setComment: value => dispatch(actions.setComment(value)),
    confirm: () => dispatch(actions.confirm()),
    openCosts: () => dispatch(costsActions.setOpen(true)),
    getCards: () => dispatch(cardActions.fetch()),
    getTransactionCost: () => dispatch(actions.fetchTransactionCost()),
    selectCard: (card) => dispatch(actions.selectCard(card)),
    modifyTransaction: () => dispatch(actions.modifyTransaction()),
    updateUrl: () => dispatch(push({search: '?s=resumen'})),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/depositV2/containers/summary.js